module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"brands":"Brands","clearAllFilters":"Clear all filters"},"lng_id":{"brands":"Brands","clearAllFilters":"Clear all filters"},"lng_th":{"brands":"Brands","clearAllFilters":"Clear all filters"},"lng_zh":{"brands":"品牌","clearAllFilters":"清除所有篩選條件"},"lng_ko":{"brands":"브랜드","clearAllFilters":"모든 필터 해제"}}')
  delete Component.options._Ctor
}
